import SectionWrapper from "components/layouts/SectionWrapper";
import { Box, Stack } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "contexts/AppContext";


const BannerSection = (props) => {
    const { styleGuide, brandData } = useContext(AppContext)
    const { bannerImageUrl, backgroundColor, backgroundHeightPct, headerSection, textBackgroundColor, children } = props

    const headerBg = brandData?.features?.themeOneMenuBarBackgroundColor
    const halfRemainingHeigh = (100 - backgroundHeightPct) / 2
    const wrapperProps = backgroundHeightPct
        ? {
            background: `linear-gradient(to bottom, ${headerSection && headerBg ? headerBg : 'transparent'} ${halfRemainingHeigh}%, ${backgroundColor} ${halfRemainingHeigh}%,
            ${backgroundColor} ${100 - halfRemainingHeigh}%, transparent ${100 - halfRemainingHeigh}%);`
        }
        : { backgroundColor: backgroundColor }

    return (
        <SectionWrapper {...wrapperProps} >
            <Box>
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    alignItems="stretch"
                    backgroundColor={textBackgroundColor}
                >
                    <Box flex={100} flexDirection={'column'} overflow={'hidden'}>
                        <Box
                            flex={1}
                            sx={{minHeight: {md: '100%'}}}
                            style={{
                                backgroundImage: `url(${bannerImageUrl})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundColor: styleGuide.color3,
                                aspectRatio: 10 / 6,
                            }}
                        />
                    </Box>

                    <Box flex={72} minWidth={320} justifyContent={'center'} alignContent={'center'}>
                        {children}
                    </Box>
                </Stack>
            </Box>
        </SectionWrapper>
    )
}

export default BannerSection